export default "__VITE_ASSET__fa3fd263__"